import { TableHeader } from "@/models/TableHeader";

export const facilityHeaders: TableHeader[] = [
  {
    text: "Location Code",
    value: "location_code"
  },
  {
    text: "Facility Name",
    value: "name"
  },
  {
    text: "Street Address",
    value: "street_address"
  },
  {
    text: "City",
    value: "city"
  },
  {
    text: "State",
    value: "state"
  },
  {
    text: "Actions...",
    value: null,
    sortable: false
  }
];
